// import styled from "styled-components";

// const Wrapper = styled.section`
//   width: 100%;
//   background: var(--background-secondary-color);
//   padding: 2rem 1.5rem;
//   border-radius: var(--border-radius);

//   .form-row {
//     display: flex;
//     flex-direction: column;
//     margin-bottom: 1rem;
//     width: 100%;
//     align-items: flex-start;
//   }

//   label {
//     font-weight: bold;
//     margin-bottom: 0.5rem;
//   }

//   select {
//     padding: 0.5rem;
//     border: 1px solid var(--grey-500);
//     border-radius: var(--borderRadius);
//     font-size: 1rem;
//     width: 100%;
//   }

//   .btn-container {
//     display: flex;
//     justify-content: flex-start;
//     gap: 1rem;
//     margin-top: 0.5rem;

//     button {
//       height: 35px;
//       padding: 0 1rem;
//       font-size: 0.9rem;
//       border-radius: var(--border-radius);
//       cursor: pointer;
//       transition: all 0.3s ease;
//     }

//     .btn-secondary {
//       background: #059212;
//       color: white;
//     }

//     .btn-secondary:hover {
//       background: #06d001;
//     }

//     .btn-danger {
//       background: #f5004f;
//       color: white;
//     }

//     .btn-danger:hover {
//       background: var(--black);
//     }
//   }

//   .selected-list {
//     margin-top: 2rem;

//     ul {
//       list-style: none;
//       padding: 0;
//     }

//     li {
//       margin-bottom: 0.5rem;
//       font-size: 0.9rem;

//       strong {
//         font-size: 1rem;
//         color: var(--primary-color);
//       }
//     }
//   }

//   @media (min-width: 768px) {
//     .form-row {
//       flex-direction: row;
//       align-items: center;
//       justify-content: space-between;
//     }

//     label {
//       margin-bottom: 0;
//       margin-right: 1rem;
//     }

//     select {
//       flex: 1;
//     }

//     .btn-container {
//       flex: 1;
//       justify-content: flex-end;
//     }
//   }

//   @media (min-width: 992px) {
//     ${'' /* padding: 3rem 2rem; */}

//     .form-row {
//       flex-direction: row;
//       justify-content: space-between;
//       .btn.btn-secondary {
//         margin-bottom: 20px;
//       }
//       .btn-danger{
//         margin-bottom: 20px;
//       }
//     }
//   }
// `;

// export default Wrapper;


import styled from "styled-components";

const Wrapper = styled.section`
  width: 100%;
  max-width: 100%;
  background: var(--background-secondary-color);
  padding: 2rem 1.5rem;
  border-radius: var(--border-radius);

  .form-container {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .form-row {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
  }

  .columns {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: space-between;
  }

  .column {
    flex: 1;
    min-width: 200px;
  }

  .building-checkboxes {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .checkbox-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
  }

  .selected-list {
    margin-top: 2rem;

    ul {
      list-style: none;
      padding: 0;
    }

    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.5rem;
      background: var(--white);
      padding: 0.5rem;
      border-radius: var(--border-radius);
      box-shadow: var(--shadow-1);
    }

    .remove-btn {
      background: transparent;
      border: none;
      color: var(--red-dark);
      font-size: 1rem;
      cursor: pointer;
      transition: all 0.3s ease;
    }

    .remove-btn:hover {
      color: var(--red-light);
    }
  }

  @media (min-width: 768px) {
    .form-row {
      flex-direction: row;
      align-items: flex-start;
      gap: 1.5rem;
    }
  }
`;

export default Wrapper;
